import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';
import { Tour } from 'src/app/model/tour/tour';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _get, _post } from '../../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class EmployeeDateTourControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res: Tour) => {
    if (res != null) {
      this.processTour(res);
    }
    return res;
  };

  private readonly deserializeArray = (res: Tour[]) => {
    if (CollectionHelper.isPopulated(res)) {
      res.forEach((t) => this.processTour(t));
    }
    return res;
  };

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get('/tours', requestServices);
    this.post = _post('/tours', requestServices);
  }

  public employeeDateTour(placerId: number, dateString: string): Promise<Tour> {
    return this.get(
      `/placerTour/${placerId}/${dateString}`,
      this.deserialize
    ).toPromise();
  }

  public multiplePlacerTours(
    requestObjects: MultiplePlacerToursRequestObject[]
  ): Promise<Tour[]> {
    const body: RequestBody = {
      items: requestObjects,
    };
    return this.post(
      `/multiplePlacerTours`,
      body,
      this.deserializeArray
    ).toPromise();
  }

  private processTour(tour: Tour): void {
    tour.date = tour.date == null ? null : DateHelper.parseDate(tour.date);
  }
}

export interface MultiplePlacerToursRequestObject {
  employeeId: number;
  dateString: string;
}

interface RequestBody {
  items: MultiplePlacerToursRequestObject[];
}
